import { IInitialData, IUser } from './users.types'
import axios from 'axios'
import config from '../../../config'
import { HTTPResponse } from '../../../services/http/http.types'
import http, { handleHttpError, handleHttpResponse } from '../../../services/http'

const getSelfInfo = async (accessToken): Promise<HTTPResponse<IInitialData>> => {
  return axios
    .get(config.API_URL + '/nsi/v1/self/init', {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createUser = (
  user: Pick<IUser, 'email' | 'name' | 'userRole'> & { password: string }
): Promise<HTTPResponse<Omit<IUser, 'role'>>> => {
  return http.post('/nsi/v1/users', user).then(handleHttpResponse).catch(handleHttpError)
}

const updateUser = (
  user: Partial<IUser> & { password?: string },
  id: IUser['id']
): Promise<HTTPResponse<Omit<IUser, 'role'>>> => {
  return http.patch(`/nsi/v1/users/${id}`, user).then(handleHttpResponse).catch(handleHttpError)
}

const deleteUser = (id: IUser['id']): Promise<HTTPResponse<Omit<IUser, 'role'>>> => {
  return http.delete(`/nsi/v1/users/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const usersApi = { getSelfInfo, createUser, updateUser, deleteUser }

export default usersApi
